import { render, staticRenderFns } from "./wosForm.vue?vue&type=template&id=358488ae&scoped=true"
import script from "./wosForm.vue?vue&type=script&lang=js"
export * from "./wosForm.vue?vue&type=script&lang=js"
import style0 from "./wosForm.vue?vue&type=style&index=0&id=358488ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358488ae",
  null
  
)

export default component.exports